import { ReactComponent as PanSvg } from './icons/pan.svg'
import { ReactComponent as RotateSvg } from './icons/rotate.svg'
import { ReactComponent as ZoomInSvg } from './icons/zoom-in.svg'
import { ReactComponent as ZoomOutSvg } from './icons/zoom-out.svg'
import { ReactComponent as ZoomAllSvg } from './icons/zoom-all.svg'
import { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { EngineContext } from '@/App';
import { PythaEventZoomInOut, PythaEventZoomAll, SETTING_KEY, PythaEventSetting } from 'pytha2'

/**
 * 摄像机类型枚举
 * - Orthographic: 正交视图。
 * - Perspective: 透视视图。
 */
export enum CAMERA_TYPE {
    Orthographic,
    Perspective
}
/**
 * 主页面绘图区：提供图形视图的显示容器
 * @returns 
 */
export default function Viewport() {
    const engineContext = useContext(EngineContext);

    /**
     * 从引擎上下文中解构获取命令触发函数 `emitCommand`。
     */
    const { emitCommand, engine } = useContext(EngineContext);

    /**
* 视口dom的ref
*/
    const viewportRef = useRef(null);

    /**
     * 当前激活的工具按钮编号
     * - 1: 平移视图
     * - 2: 旋转视图
     */
    const [activeTool, setActiveTool] = useState<number>(0);

    const clickZoomInOut = (isZoomIn = true) => {
        const pythaEvent = new PythaEventZoomInOut();
        pythaEvent.data = isZoomIn;
        engineContext.engine.eventMediator?.emitEvent(pythaEvent);
    }

    const clickZoomAll = () => {
        const pythaEvent = new PythaEventZoomAll();
        pythaEvent.data = {};
        engineContext.engine.eventMediator?.emitEvent(pythaEvent);
    }

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target === viewportRef.current) {
                    if (engine) {
                        let event = new PythaEventSetting();
                        event.data = { key: SETTING_KEY.CANVAS_RESIZE, value: null }
                        engine?.eventMediator?.emitEvent(event);
                    }
                }
            }
        });

        // Start observing the element
        if (viewportRef.current) {
            resizeObserver.observe(viewportRef.current);
        }

        // Cleanup the observer when the component unmounts
        return () => {
            if (viewportRef.current) {
                resizeObserver.unobserve(viewportRef.current);
            }
        };
    }, [engine]);

    return (
        <>
            <div id="viewport" className="viewport" ref={viewportRef}
                onClick={(e) => { }}
                onMouseEnter={() => {
                    let domElement = engineContext?.engine?.storage?.viewportStore?.renderer?.domElement;
                    if (domElement == null) return;
                    domElement.focus();
                }}
            >

            </div>
            {/* <div className="toolbar">
                <div className={classNames({
                    'tool-btn': true,
                    'is-active': activeTool == 1
                })} onClick={() => {
                    setActiveTool(1)
                    emitCommand('PAN');
                }}>
                    <PanSvg />
                </div>
                <div className={classNames({
                    'tool-btn': true,
                    'is-active': activeTool == 2
                })} onClick={() => {
                    setActiveTool(2)
                    emitCommand('3DO');
                }}>
                    <RotateSvg />
                </div>
                <div className='tool-btn' onClick={() => clickZoomInOut()}>
                    <ZoomInSvg />
                </div>
                <div className='tool-btn' onClick={() => clickZoomInOut(false)}>
                    <ZoomOutSvg />
                </div>
                <div className='tool-btn' onClick={() => clickZoomAll()}>
                    <ZoomAllSvg />
                </div>
            </div> */}
        </>

    )
}